import SessionCheck from "../common/SesionCheck";

class CommunitySdk {
  constructor() {
    // cnb 생성 시 및 15분 간격으로 인증 확인 API 호출
    new SessionCheck();
  }
}

export default CommunitySdk;